import React, { FunctionComponent } from 'react'
import { Circle, Rect, Svg } from 'react-native-svg'

import { Tooltip } from '../../atoms/tooltip/Tooltip'
import { colors } from '../../styles/colors'
import { tID } from '../../utils/utils'

export const CoachingIcon: FunctionComponent<CoachingIconProps> = ({
  showTooltip = true,
  tooltip = 'Coaching',
  width = 44,
  height = 44,
}) => {
  const icon = (
    <Svg width={width} height={height} viewBox={'0 0 52 52'} testID={tID('CoachingIcon')}>
      <Rect width={52} height={52} rx={4} fill={colors.navy1} />
      <Circle cx={26} cy={12} r={6} fill={colors.navy3} />
      <Circle cx={26} cy={40} r={6} fill={colors.navy3} />
      <Circle cx={40} cy={26} r={6} fill={colors.navy3} />
      <Circle cx={12} cy={26} r={6} fill={colors.navy3} />
    </Svg>
  )

  return showTooltip ? (
    <Tooltip content={tooltip} placement='bottom' hoverEnabled={true}>
      {icon}
    </Tooltip>
  ) : (
    <>{icon}</>
  )
}

export type CoachingIconProps = {
  showTooltip?: boolean
  tooltip?: string
  width?: number
  height?: number
}
